const buttonsLayoutStyle = `
  <style>
        .title {
          text-transform: uppercase;
          font-size: 13px;
          font-weight: normal;
          color: #8f9494;
          margin: 10px 0;
        }
        .text {
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          letter-spacing: 0.42px;
        }
        .options-container {
          display: flex;
          flex-wrap: wrap;
        }
        button {
          margin: 5px;
          font-size: 1em;
          color: black;
          background-color: white;
          cursor: pointer;
          border: 1px solid #8F9494;
          border-radius: 9px;
          display: flex;
          flex-direction: row;
          padding: 4px 12px;
          justify-content: center;
          align-items: center;
          gap: 10px;
        }
        button.selected {
          background-color: #D5FFF7;
        }
        .error-message {
          display: none;
          color: #CE5347;
          font-size: 14px;
          margin-top: 10px;
        }
        .error-message.show {
          display: block;
        }
        @media (max-width: 900px) {
          .title {
            font-size: 12px;
          }
        }
        @media (min-width: 690px) {
          button:hover {
            background-color: #D5FFF7;
          }
        }
      </style>

`;

export { buttonsLayoutStyle };
